import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core'
import { UIChart } from 'primeng/chart'
import { Subscription } from 'rxjs'
import { delay, repeatWhen } from 'rxjs/operators'
import { Dashlet, EntityReference } from '../../../..'
import { ActionService } from '../../../../../action-module'

@Component({
  selector: 'jml-lib-chart-dashlet',
  templateUrl: './chart-dashlet.component.html',
  styleUrls: ['./chart-dashlet.component.scss']
})
export class ChartDashletComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() dashlet: Dashlet
  @Input() entityReference: EntityReference

  @ViewChild('chart') chart: UIChart
  @ViewChild('description') descriptionSpan: ElementRef

  data
  options = {}
  height = '100%'
  datapointCount = 0
  updateSubscription: Subscription

  constructor(
    private actionService: ActionService,
    private cdRef: ChangeDetectorRef
  ) {}

  initActionObservable() {
    if (!!this.dashlet.actionHrid) {
      let chartData$ = this.actionService.executeAction(
        {
          actionHrid: this.dashlet.actionHrid,
          entityReference: this.entityReference
        },
        false
      )

      if (!!this.dashlet.refreshInterval) {
        chartData$ = chartData$.pipe(
          repeatWhen((completed) => completed.pipe(delay(this.dashlet.refreshInterval * 1000)))
        )
      }

      this.updateSubscription = chartData$.subscribe((response) => {
        const chartData = JSON.parse(response['result'])
        this.data = chartData['data']

        if (!this.data['labels']) {
          this.datapointCount = this.data.datasets[0].data.length
          //this.data['labels'] = [...Array(this.datapointCount).keys()]
        }

        this.options = chartData['options']
      })
    }
  }

  ngOnInit(): void {
    this.initActionObservable()
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe()
  }

  ngAfterViewInit(): void {
    const spanHeight = (<HTMLElement>this.descriptionSpan.nativeElement).clientHeight
    this.height = `calc(100% - ${spanHeight}px)`
    this.cdRef.detectChanges()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entityReference && !changes.entityReference.firstChange) {
      this.initActionObservable()
    }
  }
}
